module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('div', {
    staticClass: "profile-top",
    style: ({
      backgroundImage: 'url(' + _vm.userDetail.coverImage + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-bottom"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary pointer",
      "size": "100"
    },
    on: {
      "click": function($event) {
        return _vm.openNewWindowViewImage(_vm.userDetail.image)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "font-50 white--text"
  }, [_vm._v("\n                        " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                      ")])]), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.isShowViewImageModal),
      callback: function($$v) {
        _vm.isShowViewImageModal = $$v
      },
      expression: "isShowViewImageModal"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.userDetail.image
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-content mb-5"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h1', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.userDetail.nickName) + " (" + _vm._s(_vm.userDetail.reputationScore) + ")")]), _vm._v(" "), _c('h3', [_vm._v("IOB Power: "), _c('span', {
    staticClass: "font-26 primary--text"
  }, [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.userDetail.iobPower != null ? _vm.userDetail.iobPower : 0).toFixed(2)))))])]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-500 mt-3"
  }, [_c('span', {
    staticClass: "mx-3"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-at")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])], 1), _vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-calendar-alt")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.regTimeFormat(_vm.userDetail.regTime)))])], 1)]), _vm._v(" "), (_vm.username != this.$store.state.user.name) ? _c('div', {
    staticClass: "social-list clearfix mb-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.follow
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFollow),
      expression: "!isFollow"
    }]
  }, [_c('Icon', {
    attrs: {
      "type": "plus-round",
      "color": "#FFFFFF"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("common.follow")))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFollow),
      expression: "isFollow"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.unfollow")))])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h4 mt-3"
  }, [_c('span', {
    staticClass: "primary--text pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.goFollow('following')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.followingNum) + " " + _vm._s(_vm.$t("follow.following")) + "\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "primary--text pointer ml-2",
    on: {
      "click": function($event) {
        return _vm.goFollow('followers')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.followerNum) + " " + _vm._s(_vm.$t("follow.followers")) + "\n                      ")])])])])])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": "",
      "mb-5": "",
      "pb-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "inbox-head"
  }, [_c('div', {
    staticClass: "mailbox-items-warp"
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.posting') + '(' + _vm.totalPostingNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('posting')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-file-alt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.posting")) + "(" + _vm._s(_vm.totalPostingNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.comments') + '(' + _vm.totalRewardRecordsNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('comments')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-comment")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.comments")) + "(" + _vm._s(_vm.totalCommentsNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.reply') + '(' + _vm.totalReplyNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('reply')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-reply")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.reply")) + "(" + _vm._s(_vm.totalReplyNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.forward') + '(' + _vm.totalForwardNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('forward')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-share")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.forward")) + "(" + _vm._s(_vm.totalForwardNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.upvotes') + '(' + _vm.totalUpvoteNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('upvotes')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("thumb_up")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.upvotes")) + "(" + _vm._s(_vm.totalUpvoteNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.downvotes') + '(' + _vm.totalDownvoteNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('downvotes')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("thumb_down")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.downvotes")) + "(" + _vm._s(_vm.totalDownvoteNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.favorites') + '(' + _vm.totalCollectionPostNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('collections')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-star")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.favorites")) + "(" + _vm._s(_vm.totalCollectionPostNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.referees') + '(' + _vm.userDetail.invitationNumber + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('referees')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("accessibility")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.referees")) + "(" + _vm._s(_vm.userDetail.invitationNumber) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.rewardRecords') + '(' + _vm.totalRewardRecordsNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('rewardRecords')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-clipboard")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.rewardRecords")) + "(" + _vm._s(_vm.totalRewardRecordsNum) + ")\n                        ")])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "inbox-content",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg9": ""
    }
  }, [_c('div', {
    staticClass: "inbox-content-wrap"
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPosting),
      expression: "isShowPosting"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.posting")))]), _vm._v(" "), _vm._l((_vm.postingList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image pointer",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v("\n                                      " + _vm._s(posting.postingGoodnums) + "\n                                  ")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v("\n                                      " + _vm._s(posting.postingStepnums) + "\n                                  ")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v("\n                                    " + _vm._s(posting.postingCountComments) + "\n                              ")])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingList.length > 0),
      expression: "postingList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalPostingNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getPostingByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMicroArticle),
      expression: "isShowMicroArticle"
    }]
  }, [_c('h2', {
    staticClass: "fw-bold mt-5 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.microArticle")))]), _vm._v(" "), _vm._l((_vm.microArticleList), function(microArticle, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('div', {
      staticClass: "mt-3 mb-3 ml-3 mr-3"
    }, [_c('div', {
      staticClass: "mt-3 font-md pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(microArticle.content) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "mr-5 right"
    }, [_c('v-icon', {
      class: {
        'primary--text': microArticle.isUpvote
      },
      attrs: {
        "small": "",
        "title": _vm.$t('posting.upvote')
      },
      on: {
        "click": function($event) {
          return _vm.voteMicroArticle(microArticle, '0')
        }
      }
    }, [_vm._v("thumb_up")]), _vm._v("\n                      " + _vm._s(microArticle.upvoteCount) + "\n                      "), _c('v-icon', {
      staticClass: "ml-3",
      attrs: {
        "small": "",
        "title": _vm.$t('posting.comment')
      },
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v("\n                      " + _vm._s(microArticle.commentCount) + "\n                    ")], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "mt-5"
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.microArticleList.length > 0),
      expression: "microArticleList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalMicroArticleNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getMicroArticleByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowComments),
      expression: "isShowComments"
    }]
  }, [_c('h3', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.comments")))]), _vm._v(" "), _vm._l((_vm.postingCommentsList), function(comments, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [_c('div', {
      staticClass: "media-body"
    }, [_vm._l((_vm.commentsPostingList), function(posting, index) {
      return _c('div', [(comments.commentsPostingId == posting.postingId) ? _c('p', {
        staticClass: "font-16 fw-500",
        on: {
          "click": function($event) {
            return _vm.getPostingById(posting.postingId)
          }
        }
      }, [_c('span', {
        staticClass: "fw-700"
      }, [_vm._v(_vm._s(_vm.$t("userData.posting")) + ":")]), _vm._v("\n                               " + _vm._s(posting.postingTitle) + "\n                            ")]) : _vm._e()])
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [_c('span', {
      staticClass: "fw-700"
    }, [_vm._v(_vm._s(_vm.$t("userData.comment")) + ":")]), _vm._v(" "), (comments.commentsContext.length = 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (comments.commentsContext.length < 30) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n                              " + _vm._s(comments.commentsContext) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(comments.commentsContext) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(" " + _vm._s(comments.postingCommentsGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(comments.postingCommentsStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(" " + _vm._s(comments.postingCommentList.length))])], 1)])])], 2)])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingCommentsList.length > 0),
      expression: "postingCommentsList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalCommentsNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getCommentsByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReply),
      expression: "isShowReply"
    }]
  }, [_c('h3', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.reply")))]), _vm._v(" "), _vm._l((_vm.postingReplyList), function(reply, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [_c('div', {
      staticClass: "media-body"
    }, [_vm._l((_vm.parentCommentList), function(comments, index) {
      return _c('div', [(comments.commentsId == reply.parentCommentId) ? _c('p', {
        staticClass: "font-16 fw-500 word-break",
        on: {
          "click": function($event) {
            return _vm.getPostingById(comments.commentsPostingId)
          }
        }
      }, [_c('span', {
        staticClass: "fw-700"
      }, [_vm._v(_vm._s(_vm.$t("userData.comment")) + "：")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(comments.commentsContext)
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [_c('span', {
      staticClass: "fw-700"
    }, [_vm._v(_vm._s(_vm.$t("userData.reply")) + "：")]), _vm._v(" "), (reply.commentsContext.length = 0) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (reply.commentsContext.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(reply.commentsContext) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(reply.commentsContext) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {}
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(" " + _vm._s(reply.postingCommentsGoodnums))])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {}
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(" " + _vm._s(reply.postingCommentsStepnums))])], 1)])])], 2)])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingReplyList.length > 0),
      expression: "postingReplyList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalReplyNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getReplyByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowForward),
      expression: "isShowForward"
    }]
  }, [_c('h3', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.forward")))]), _vm._v(" "), _vm._l((_vm.postingForwardList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('div', {
      staticClass: "font-md mt-3"
    }, [_c('v-icon', [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700 mr-1"
    }, [_vm._v(_vm._s(_vm.$t("userData.forwarded")))])], 1), _vm._v(" "), _c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingForwardList.length > 0),
      expression: "postingForwardList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalForwardNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getForwardByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUpvotes),
      expression: "isShowUpvotes"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.upvotes")))]), _vm._v(" "), _vm._l((_vm.upvotePostList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upvotePostList.length > 0),
      expression: "upvotePostList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalUpvoteNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getUpvotePostListByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDownvotes),
      expression: "isShowDownvotes"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.downvotes")))]), _vm._v(" "), _vm._l((_vm.downvotePostList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downvotePostList.length > 0),
      expression: "downvotePostList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalDownvoteNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getDownvotePostListByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCollections),
      expression: "isShowCollections"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.favorites")))]), _vm._v(" "), _vm._l((_vm.collectionPostList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectionPostList.length > 0),
      expression: "collectionPostList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalCollectionPostNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getCollectionPostByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReferrals),
      expression: "isShowReferrals"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.referees")))]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.referralList), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-3 mb-3 app-card"
    }, [_c('div', {
      staticClass: "text-xs-center follow-w mb-3 mt-2 profile-card-bg",
      style: ({
        backgroundImage: 'url(' + user.coverImage + ')'
      })
    }, [_c('v-avatar', {
      staticClass: "pointer mt-4",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                              " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                            ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "user-list-content"
    }, [_c('div', {
      staticClass: "text-xs-center pt-2"
    }, [_c('h4', {
      staticClass: "fw-bold pointer",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v(_vm._s(user.nickName))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(user.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center mb-2"
    }, [(user.userId != _vm.userId) ? _c('div', [_c('v-btn', {
      staticClass: "primary",
      attrs: {
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.referralFollow(user.userId)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? true : false),
        expression: "user.status == '1' ? true : false"
      }]
    }, [_vm._v("\n                                  " + _vm._s(_vm.$t("common.unfollow")) + "\n                                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? false : true),
        expression: "user.status == '1' ? false : true"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "white--text"
      }
    }), _vm._v("\n                                  " + _vm._s(_vm.$t("common.follow")) + "\n                                ")], 1)])], 1) : _vm._e()])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowRewardRecords),
      expression: "isShowRewardRecords"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.rewardRecords")))]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 mb-5",
    attrs: {
      "headers": _vm.bonusRecordTableHeaders,
      "items": _vm.bonusRecordList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(_vm.dateFormat(props.item.actionTimestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormat(props.item.timestamp)))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          on: {
            "click": function($event) {}
          }
        }, [_c('router-link', {
          attrs: {
            "to": '/post/' + props.item.postId
          }
        }, [_vm._v("\n                            " + _vm._s(props.item.bonus != null ? props.item.bonus.toFixed(4) : 0.0000) + " IOB Power for " + _vm._s(props.item.type) + "\n                          ")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bonusRecordList.length > 0),
      expression: "bonusRecordList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalRewardRecordsNum,
      "pageSize": 10,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getBonusRecordsListByPage
    }
  })], 1)], 1)])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d411607"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/UserData.vue
// module id = 414
// module chunks = 0